import { Link } from "react-router-dom";
import { Search, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useState } from "react";
import ThemeToggle from "@/components/ThemeToggle";

const Header = () => {
  const [open, setOpen] = useState(false);

  const navLinks = [
    { to: "/categories", label: "Categories" },
    { to: "/glossary", label: "Glossary" },
    { to: "/tools", label: "Tools" },
    { to: "/about", label: "About" },
  ];

  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      {/* Thin accent bar */}
      <div className="h-[2px] bg-accent-warm w-full" />

      {/* Editorial dateline strip */}
      <div className="hidden md:block border-b border-border/60 bg-surface-sunken">
        <div className="container flex h-7 items-center justify-between text-[10px] uppercase tracking-[0.18em] text-muted-foreground tabular-figures">
          <span className="inline-flex items-center gap-2.5">
            {today}
          </span>
          <span className="font-heading italic normal-case tracking-normal text-[11px] inline-flex items-center gap-2.5">
            <span className="gold-dot" aria-hidden />
            A reference for modern life
            <span className="gold-dot" aria-hidden />
          </span>
          <span className="font-heading italic normal-case tracking-normal text-[11px] text-accent-warm">
            Vol. II · No. 06
          </span>
        </div>
      </div>

      <header className="sticky top-0 z-50 w-full bg-background/98 backdrop-blur supports-[backdrop-filter]:bg-background/90">
        <div className="container flex h-20 items-center justify-between">
          <Link to="/" className="flex items-center">
            <span className="font-heading text-2xl font-bold text-foreground tracking-tight">
              Life Basics Guide
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors uppercase tracking-[0.15em] link-underline"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-1">
            <ThemeToggle />
            <Link to="/search">
              <Button variant="ghost" size="icon" aria-label="Search">
                <Search className="h-4 w-4" />
              </Button>
            </Link>

            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon" aria-label="Menu">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-72">
                <nav className="flex flex-col gap-6 mt-12">
                  {navLinks.map((link) => (
                    <Link
                      key={link.to}
                      to={link.to}
                      onClick={() => setOpen(false)}
                      className="text-sm font-medium text-foreground hover:text-muted-foreground transition-colors uppercase tracking-[0.1em]"
                    >
                      {link.label}
                    </Link>
                  ))}
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
        {/* Thin bottom rule */}
        <div className="h-[1px] bg-border" />
      </header>
    </>
  );
};

export default Header;
